import usuarioStore from "./store/usuario";

function regrasDescontoProduto(context, produto, vcto) {
  var indicePercDesconto = -1;

  indicePercDesconto = context.state.config.regrasdesconto.findIndex(
    (rd) =>
      rd.cliente == context.state.novopedido.cliente.matricula &&
      rd.gp == produto.gp &&
      rd.sgp == produto.sgp &&
      rd.item == produto.item
  );

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) =>
        rd.cliente == context.state.novopedido.cliente.matricula &&
        rd.gp == produto.gp &&
        rd.sgp == produto.sgp &&
        rd.item == 0
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) =>
        rd.cliente == context.state.novopedido.cliente.matricula &&
        rd.gp == produto.gp &&
        rd.sgp == 0 &&
        rd.item == 0
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) =>
        rd.cliente == context.state.novopedido.cliente.matricula &&
        rd.gp == 0 &&
        rd.sgp == 0 &&
        rd.item == 0
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) =>
        rd.vendedor == context.state.novopedido.cliente.vendedor.cod &&
        rd.gp == produto.gp &&
        rd.sgp == produto.sgp &&
        rd.item == produto.item
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) =>
        rd.vendedor == context.state.novopedido.cliente.vendedor.cod &&
        rd.gp == produto.gp &&
        rd.sgp == produto.sgp &&
        rd.item == 0
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) =>
        rd.vendedor == context.state.novopedido.cliente.vendedor.cod &&
        rd.gp == produto.gp &&
        rd.sgp == 0 &&
        rd.item == 0
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) =>
        rd.vendedor == context.state.novopedido.cliente.vendedor.cod &&
        rd.gp == 0 &&
        rd.sgp == 0 &&
        rd.item == 0
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) =>
        rd.gp == produto.gp && rd.sgp == produto.sgp && rd.item == produto.item
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) => rd.gp == produto.gp && rd.sgp == produto.sgp && rd.item == 0
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) => rd.gp == produto.gp && rd.sgp == 0 && rd.item == 0
    );
  }

  if (indicePercDesconto < 0) {
    indicePercDesconto = context.state.config.regrasdesconto.findIndex(
      (rd) =>
        rd.cliente == "" &&
        rd.vendedor == 0 &&
        rd.gp == 0 &&
        rd.sgp == 0 &&
        rd.item == 0
    );
  }

  if (indicePercDesconto >= 0) {
    var indicePercentuais = context.state.config.regrasdesconto[
      indicePercDesconto
    ].percentuais.findIndex((p) => vcto.dias <= p.dias);

    if (indicePercentuais >= 0) {
      var percSelec =
        context.state.config.regrasdesconto[indicePercDesconto].percentuais[
          indicePercentuais
        ];

      if (usuarioStore.state.usuarioLogado.representante) {
        produto.maxdesconto = percSelec.maxdescvend;
        produto.mindesconto = percSelec.mindescvend;
      } else {
        produto.maxdesconto = percSelec.maxdescfunc;
        produto.mindesconto = percSelec.mindescfunc;
      }

      if (
        produto.comissaomax > percSelec.maxdescvend &&
        percSelec.maxdescvend > 0
      ) {
        produto.comissaomax = percSelec.maxdescvend;
      }
    }
  } else {
    produto.maxdesconto = 0;
    produto.mindesconto = 0;
  }
}

export default regrasDescontoProduto;
